/**
 * Binds all the passed functions to the given arguments
 * @param {object} operations
 * @param args - Elements to be bound
 * @return {object} - Operations with the args bounded
 */
export default function(operations, ...args) {
  return Object
    .keys(operations)
    .reduce((acc, actionKey) => ({
      ...acc,
      [actionKey]: operations[actionKey].bind(operations, ...args),
    }), {})
}
